const SEGMENTS = {
    SELLER: 'dealers',
    EXCLUSIVE: 'exclusive',
} as const;

const VERTICALS = {
    FURNITURE: 'furniture',
    ART: 'art',
    JEWELRY: 'jewelry',
    FASHION: 'fashion',
} as const;

export const ROUTING_SEGMENT_MOBILE = 'mobile' as const;
export const ROUTING_SEGMENT_RESPONSIVE = 'resp' as const;

export { SEGMENTS, VERTICALS };
